import { useState } from "react";
import API from "../api";
import { useNavigate } from "react-router-dom";

export default function Register() {
  const [form, setForm] = useState({});
  const [msg, setMsg] = useState("");
  const [msgClass, setMsgClass] = useState("")
  const [registered, setRegistered] = useState(false)
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false)

  function validateEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }

  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]).{6,}$/;
  const usernameRegex = /^[a-zA-Z0-9_]{3,20}$/;

  const submit = async () => {
    if (!form.username) {
      setMsg("Adj meg egy felhasználónevet!")
      setMsgClass("text-red-500");
      return;
    }
    if (!usernameRegex.test(form.username)) {
      setMsg("A felhasználónév 3-20 karakter hosszú kell legyen, és betűt vagy számot tartalmazhat.");
      setMsgClass("text-red-500");
      return;
    }

    if (!form.email || !validateEmail(form.email)) {
      setMsg("Valós e-mail címet adj meg!");
      setMsgClass("text-red-500");
      return;
    }
    if (!form.password && !form.password2) {
      setMsg("Nem adtál meg jelszót!");
      setMsgClass("text-red-500");
      return;
    }
    if (!form.password || !form.password2) {
      setMsg("Erősítsd meg a jelszavad!");
      setMsgClass("text-red-500");
      return;
    } else {
      // Bot passwords filled out
      if (form.password !== form.password2) {
        setMsg("A megadott jelszavak nem egyeznek!");
        setMsgClass("text-red-500");
        return;
      }
      else {
        if (!passwordRegex.test(form.password)) {
          setMsg("A jelszónak legalább 6 karakter hosszúnak kell lennie, és tartalmaznia kell betűt, számot és speciális karaktert!");
          setMsgClass("text-red-500");
          return;
        }
        try {
          await API.post("/auth/register", form);
          setMsgClass("text-blue-500")
          setMsg("Admin jóváhagyás szükséges.");
          setRegistered(true);
          document.getElementById("username").disabled = true;
          document.getElementById("email").disabled = true;
          document.getElementById("displayname").disabled = true;
          document.getElementById("password").disabled = true;
          document.getElementById("password2").disabled = true;
        } catch (error) {
          // Ellenőrizd, hogy a válasznak van-e üzenete
          if (error.response && error.response.data && error.response.data.msg) {
            setMsgClass("text-red-500");
            setMsg(error.response.data.msg); // A válaszban szereplő üzenet
          } else {
            setMsgClass("text-red-500");
            setMsg("Hiba."); // Alapértelmezett üzenet hiba esetén
          }
        }
      }
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="bg-white shadow p-8 rounded w-96">
        <h2 className="text-xl mb-4">Regisztráció</h2>

        <label>
          Felhasználónév<span className="text-red-500">*</span>
          <input
            id="username"
            required
            placeholder="Username"
            className="border p-2 mb-2 w-full"
            onChange={(e) =>
              setForm({ ...form, username: e.target.value })
            }
          />
        </label>

        <label>
          E-mail cím<span className="text-red-500">*</span>
          <input
            id="email"
            required
            placeholder="user@provider.com"
            className="border p-2 mb-2 w-full"
            onChange={(e) =>
              setForm({ ...form, email: e.target.value })
            }
          />
        </label>

        <label>
          Megjelenített név
          <input
            id="displayname"
            placeholder="Name"
            className="border p-2 mb-2 w-full"
            onChange={(e) =>
              setForm({
                ...form,
                display_name: e.target.value,
              })
            }
          />
        </label>


        <label htmlFor="password">
          Jelszó<span className="text-red-500">*</span><p>
            <span className="text-xs text-gray-400 mb-2">
              {'(Minimum 6 karaktert adj meg. Tartalmaznia kell betűt, számot és speciális karaktert (!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~).)'}
            </span>
          </p>
        </label>
        <div className="flex justify-between flex-col">
          <input
            required
            id="password"
            type={checked ? "text" : "password"}
            placeholder="Password"
            className="border p-2 mb-2 w-full"
            onChange={(e) =>
              setForm({ ...form, password: e.target.value })
            }
          />
          <input
            id="password2"
            required
            type={checked ? "text" : "password"}
            placeholder="Password again"
            className="border p-2 mb-2 w-full"
            onChange={(e) =>
              setForm({ ...form, password2: e.target.value })
            }
          />
        </div>
        <div className="flex justify-center w-full gap-4">
          <label htmlFor="showpassword">Jelszó megjenelítése</label>
          <input id="showpassword" type="checkbox" onChange={(e) => setChecked(e.target.checked)} />
        </div>
        <div className="m-4"><span className="text-red-500 text-center text-xs">* kötelezően kitöltendő mezők</span>
        </div>


        <div><span className={`${msgClass} mb-4`}>{msg}</span></div>

        <button className="bg-gray-600 text-white p-2 w-full mb-4 mt-4" onClick={() => navigate("/")}>Vissza a főoldalra</button>
        {registered ? (
          <>
          </>
        ) :
          (
            <button
              className="bg-blue-600 text-white p-2 w-full"
              onClick={submit}>Regisztrálok</button>
          )}
      </div>
    </div>
  );
}